<template>
	<div class="seller-warehouse">
		<div class="btnbox">
			<el-button size="small" @click="goRecord">入仓记录</el-button>
			<el-button size="small" @click="goStock">在仓库存</el-button>
			<el-button size="small" @click="goBuyout">变现报价</el-button>
			<el-button size="small" @click="goSettle">结算中心</el-button>
			<el-button size="small" @click="goWithdraw">提现</el-button>
		</div>
		<div class="tablebox">
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="name" label="云仓名称" align="center" header-align="center" min-width="120px">
					</el-table-column>
					<el-table-column prop="buyer_username" label="仓主" align="center" header-align="center" min-width="90px">
					</el-table-column>
					<el-table-column prop="address" label="地址" align="center" header-align="center" min-width="180px">
					</el-table-column>
					<el-table-column label="可用额度" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.available_amount) }}</template>
					</el-table-column>
					<el-table-column label="保证金" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.deposit_amount) }}</template>
					</el-table-column>
					<el-table-column prop="contact_name" label="联系人" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="contact_mobile" label="电话" align="center" header-align="center" min-width="110px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="开通时间" align="center" header-align="center" width="160px">
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="110px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span v-if="canApply(scope.row)" @click="goApply(scope.row)">申请入仓</span>
								<span v-else class="disabled" @click="onFull">额度已满</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg } from './money.js'

	export default {
		name: 'SellerWarehouseList',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0
			}
		},
		mounted() {
			this.onlist()
		},
		methods: {
			fenToYuan: fenToYuan,
			canApply(row) {
				return Number(row.available_amount) > 0
			},
			onFull() {
				this.$message.warning('额度已满')
			},
			goApply(row) {
				this.$router.push({
					path: '/seller/warehouse/entry',
					query: { warehouse_id: row.id }
				})
			},
			goRecord() {
				this.$router.push('/seller/warehouse/record')
			},
			goSettle() {
				this.$router.push('/seller/warehouse/settle')
			},
			goStock() {
				this.$router.push('/seller/warehouse/stock')
			},
			goBuyout() {
				this.$router.push('/seller/warehouse/buyout')
			},
			goWithdraw() {
				this.$router.push({ path: '/seller/warehouse/settle', query: { tab: 'withdraw' } })
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onlist() {
				this.$axios.get('api/cloud_warehouse/warehouse_list', {
					params: {
						page: this.page,
						limit: this.pageSize
					}
				}).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-warehouse {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.tablediv {
		height: calc(100% - 52px);
	}

	.disabled {
		color: #C0C4CC !important;
		cursor: not-allowed;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/index.vue